export default "__VITE_ASSET__ByOeEMbl__"